// Shared between useOrder (draft auto-save) and useStep4Payment (checkout).
//
// Draft auto-save and the payment flow both POST to /projects/{user_id}. If a
// debounced draft save (orderStatus 10) lands after the card was charged, it
// overwrites the paid order back to Draft. Once a payment attempt starts, draft
// saves are locked for the rest of this wizard session, and any save already in
// flight can be awaited so the payment saves never interleave with it.

let draftSavesLocked = false;
let pendingDraftSave: Promise<unknown> | null = null;

export const lockDraftSaves = () => {
  draftSavesLocked = true;
};

export const unlockDraftSaves = () => {
  draftSavesLocked = false;
};

export const areDraftSavesLocked = () => draftSavesLocked;

export const trackDraftSave = (save: Promise<unknown>) => {
  const tracked = save.catch(() => undefined);
  pendingDraftSave = tracked;
  tracked.finally(() => {
    if (pendingDraftSave === tracked) pendingDraftSave = null;
  });
};

export const waitForPendingDraftSave = async () => {
  if (pendingDraftSave) await pendingDraftSave;
};
